import QueryString from "query-string";

class EventService {
    static formatResults = (results, highlights) => {
        let formattedResults = [];

        if (results) {
            formattedResults = results.map((result) => {
                return {
                    ...result.document,
                    isHighlight: highlights.includes(result.document.id),
                };
            });
        }

        return formattedResults;
    };

    static search = async (filters, amount, page = 1, isArchive = false) => {
        const showHighlights = !isArchive && (page === '1' && Object.keys(filters).length === 0);
        const parameters = {
            ...filters,
            a: amount,
            o: (page - 1) * amount,
            future: isArchive ? 0 : 1,
            past: isArchive ? 1 : 0,
            highlights: showHighlights ? 1 : 0,
        };

        const queryString = QueryString.stringify(parameters, {
            strict: false,
            encode: false,
        });

        const response = await fetch(`/api/events?${queryString}`);
        const json = await response.json();

        return {
            results: this.formatResults(json.results, json.highlights),
            total: json.total,
        };
    };
}

export default EventService;
